<template>
  <v-container fluid style="background-color: white">
    <v-layout row wrap fill-height justify-center>
      <v-flex xs12 sm12 md12 lg12>
        <v-card flat>
          <br />
          <v-layout justify-center>
            <v-card-title class="headlinestyle">
              <strong>แก้ไขรายการสั่งสินค้า</strong>
            </v-card-title>
          </v-layout>

          <!-- orderdetaildata -->
          <v-layout align-center>
            <v-flex xs12 sm3 md3 lg3>
              <div class="ml-10">
                <p align="right">
                  <strong>เลขที่เอกสาร : &nbsp;</strong>
                </p>
              </div>
            </v-flex>
            <v-flex xs12 sm8 md8 lg8>
              <div>
                <p>{{ orderdetaildata.order_no }}</p>
              </div>
            </v-flex>
          </v-layout>
          <v-layout align-center>
            <v-flex xs12 sm3 md3 lg3>
              <div class="ml-10">
                <p align="right">
                  <strong>รหัสร้านค้า : &nbsp;</strong>
                </p>
              </div>
            </v-flex>
            <v-flex xs12 sm8 md8 lg8>
              <div>
                <p>{{ orderdetaildata.username }}</p>
              </div>
            </v-flex>
          </v-layout>
          <v-layout align-center>
            <v-flex xs12 sm3 md3 lg3>
              <div class="ml-10">
                <p align="right">
                  <strong>เจ้าหน้าที่ผู้ดูแล : &nbsp;</strong>
                </p>
              </div>
            </v-flex>
            <v-flex xs12 sm8 md8 lg8>
              <div>
                <p>{{ orderdetaildata.adminref_name }}</p>
              </div>
            </v-flex>
          </v-layout>
          <v-layout align-center>
            <v-flex xs12 sm3 md3 lg3>
              <div class="ml-10">
                <p align="right">
                  <strong>ชื่อ-สกุล : &nbsp;</strong>
                </p>
              </div>
            </v-flex>
            <v-flex xs12 sm8 md8 lg8>
              <div>
                <p>{{ orderdetaildata.name }}</p>
              </div>
            </v-flex>
          </v-layout>
          <v-layout align-center>
            <v-flex xs12 sm3 md3 lg3>
              <div class="ml-10">
                <p align="right">
                  <strong>ที่อยู่จัดส่ง : &nbsp;</strong>
                </p>
              </div>
            </v-flex>
            <v-flex xs12 sm8 md8 lg8>
              <div>
                <p>{{ orderdetaildata.address }}</p>
              </div>
            </v-flex>
          </v-layout>
          <v-layout align-center>
            <v-flex xs12 sm3 md3 lg3>
              <div class="ml-10">
                <p align="right">
                  <strong>เบอร์โทร : &nbsp;</strong>
                </p>
              </div>
            </v-flex>
            <v-flex xs12 sm8 md8 lg8>
              <div>
                <p>{{ orderdetaildata.tel }}</p>
              </div>
            </v-flex>
          </v-layout>
          <v-layout align-center>
            <v-flex xs12 sm3 md3 lg3>
              <div class="ml-10">
                <p align="right">
                  <strong>วันที่สั่งซื้อ : &nbsp;</strong>
                </p>
              </div>
            </v-flex>
            <v-flex xs12 sm8 md8 lg8>
              <div>
                <p>{{ order_date_th }}</p>
              </div>
            </v-flex>
          </v-layout>
          <v-layout align-start>
            <v-flex xs12 sm3 md3 lg3>
              <div class="ml-10">
                <p align="right">
                  <strong>สถานะ : &nbsp;</strong>
                </p>
              </div>
            </v-flex>
            <v-flex xs12 sm8 md8 lg8>
              <div>
                <v-chip
                  :color="getColor(orderdetaildata.order_status)"
                  text-color="white"
                  >{{ orderdetaildata.order_status_th }}</v-chip
                >
              </div>
            </v-flex>
          </v-layout>
          <v-layout align-start>
            <v-flex xs12 sm3 md3 lg3>
              <div class="ml-10">
                <p align="right">
                  <strong>การชำระเงิน : &nbsp;</strong>
                </p>
              </div>
            </v-flex>
            <v-flex xs12 sm8 md8 lg8>
              <div>
                <v-chip
                  :color="getColor(orderdetaildata.payment_status)"
                  outlined
                  >{{ orderdetaildata.payment_status_th }}</v-chip
                >
              </div>
            </v-flex>
          </v-layout>
          <v-layout align-center v-if="delivery_date_th">
            <v-flex xs12 sm3 md3 lg3>
              <div class="ml-10">
                <p align="right">
                  <strong>วันที่จัดส่ง : &nbsp;</strong>
                </p>
              </div>
            </v-flex>
            <v-flex xs12 sm8 md8 lg8>
              <div>
                <p>{{ delivery_date_th }}</p>
              </div>
            </v-flex>
          </v-layout>

          <!-- add button -->
          <v-layout row wrap justify-end>
            <v-flex xs4 sm3 md3 lg3>
              <v-btn
                class="mx-2"
                outlined
                color="indigo lighten-2"
                @click="openorderproductmodal()"
              >
                <v-icon>mdi-plus</v-icon>&nbsp; เพิ่ม/แก้ไข
              </v-btn>
            </v-flex>
          </v-layout>
          <br />
          <v-layout justify-center>
            <v-flex xs12 sm9 md9 lg9>
              <v-data-table
                :headers="headers"
                :items="productitems"
                hide-default-footer
                :items-per-page="1000"
                class="elevation-2"
                item-key="_id"
                disable-pagination
              >
                <template v-slot:body="{ items }">
                  <tbody>
                    <tr
                      v-for="item in items"
                      :key="item._id"
                      style="cursor: pointer"
                      align="center"
                    >
                      <td>{{ item.product_no }}</td>
                      <td>
                        <v-container class="con">
                          <v-img
                            class="white--text align-center"
                            style="height: 100px; width: 130px"
                            :src="item.image"
                            v-if="item.image"
                          ></v-img>
                        </v-container>
                      </td>
                      <td>{{ item.name }}</td>
                      <td v-if="!claim">{{ item.price }}</td>
                      <td v-if="claim">0</td>
                      <td>{{ item.quantity }}</td>
                      <td>{{ item.type }}</td>
                      <td>
                        <v-btn
                          class="ma-2"
                          outlined
                          small
                          fab
                          color="red"
                          @click="deleteproduct(item._id)"
                        >
                          <v-icon meduim>mdi-delete-forever</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                    <br />
                    <tr>
                      <td />
                      <td />
                      <td />
                      <td />
                      <td />
                      <td>
                        <div>
                          <p align="right">
                            <strong>รวม</strong>
                            <small style="color: black">(ราคาไม่รวมภาษี)</small>
                          </p>
                        </div>
                      </td>
                      <td>
                        <p align="left" style="color: red" v-if="!claim">
                          {{ amount }}&nbsp;&nbsp;&nbsp;บาท
                        </p>
                        <p align="left" style="color: red" v-if="claim">
                          0.00&nbsp;&nbsp;&nbsp;บาท
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <br />
          <br />
          <v-layout justify-end>
            <div class="flex-grow-1"></div>

            <v-btn
              class="px-5"
              color="pink"
              style="margin-right: 5px"
              outlined
              @click="cancel()"
              >ยกเลิก</v-btn
            >

            <v-btn color="pink lighten-2" dark @click="save()">บันทึก</v-btn>
            <v-flex xs1 sm1 md1 lg1></v-flex>
          </v-layout>
          <br />
          <br />
          <div class="vld-parent">
            <loading :active.sync="isLoading" is-full-page></loading>
          </div>
          <Orderproductmodal />
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Orderproductmodal from "@/components/Orderproductmodal";
import axios from "axios";
import swal from "sweetalert";
import { sync } from "vuex-pathify";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import numeral from "numeral";
moment.locale("th");
export default {
  components: {
    Orderproductmodal,
    Loading,
  },
  data: () => ({
    headers: [
      {
        text: "รหัสซื้อขาย",
        align: "center",
        sortable: false,
        value: "product_no",
      },
      { text: "รูปสินค้า", align: "center", sortable: false, value: "image" },
      { text: "ชื่อสินค้า", align: "center", sortable: false, value: "name" },
      { text: "ราคา", align: "center", sortable: false, value: "price" },
      { text: "จำนวน", align: "center", sortable: false, value: "quantity" },
      { text: "ประเภท", align: "center", sortable: false, value: "type" },
      { text: "ลบ", align: "center", sortable: false, value: "delete" },
    ],
    useritems: [],
    customerdata: "",
    customerusername: "",
    name: "",
    address: "",
    tel: "",
    productitems: [],
    amount: "0.00",
    claim: false,
    isLoading: false,
    isclaim: false,
    orderdetaildata: {},
    order_date_th: "",
    delivery_date_th: "",
  }),
  created() {
    if (this.$cookies.get("token") !== "") {
      this.getdata();
    } else {
      this.$router.push("/");
    }
  },

  methods: {
    getColor(status) {
      if (status === "00") return "info";
      else if (status === "01") return "success";
      else if (status === "02") return "#DD4B39";
      else if (status === "10") return "#52B9EB";
      else if (status === "11") return "#F7BA38";
      else if (status === "12") return "#388E3C";
      else if (status === "13") return "#F23B22";
      else if (status === "0") return "info";
      else if (status === "1") return "warning";
      else if (status === "2") return "success";
      else if (status === "3") return "#DD4B39";
      else if (status === "4") return "#000000";
    },
    async getdata() {
      try {
        if (this.$route.params.order_id) {
          this.isLoading = true;
          let orderdata = await axios.get(
            `${process.env.VUE_APP_API}/order/get/${this.$route.params.order_id}`,
            {
              headers: {
                Authorization: this.$cookies.get("token"),
              },
            }
          );
          this.orderdetaildata = orderdata.data;
          this.currentcustomerid = this.orderdetaildata.customer_id;
          this.order_date_th = moment(orderdata.data.order_date).format("LL");
          this.delivery_date_th = orderdata.data.delivery_date
            ? moment(orderdata.data.delivery_date).format("LL")
            : "";
          this.productitems = orderdata.data.productitems.map((p) => {
            return {
              _id: p.product_id,
              image: p.image,
              name: p.name,
              price: p.price,
              product_no: p.product_no,
              quantity: p.quantity,
              type: p.type,
            };
          });
          this.isclaim = orderdata.data.order_no.includes("C");
          this.claim = orderdata.data.order_no.includes("C");
          this.setamount();
          this.isLoading = false;
        }
      } catch (error) {
        this.isLoading = false;
      }
    },
    setdata() {
      this.productitems = JSON.parse(this.currentorderproduct).filter(
        (pd) => pd.quantity > 0
      );
      this.setamount();
    },
    setamount() {
      this.amount = numeral(
        this.productitems
          ? this.productitems.reduce((sum, product) => {
              return sum + Number(product.price) * Number(product.quantity);
            }, 0)
          : 0
      ).format("0,0.00");
    },
    async save() {
      try {
        if (this.productitems.length !== 0) {
          this.isLoading = true;
          let resultproductitems = this.productitems.map((pd) => {
            return {
              product_id: pd._id,
              quantity: pd.quantity,
            };
          });
          let { data } = await axios.put(
            `${process.env.VUE_APP_API}/order/edit/productitems/${this.$route.params.order_id}`,
            {
              productitems: resultproductitems,
            },
            {
              headers: {
                Authorization: this.$cookies.get("token"),
              },
            }
          );
          if (data) {
            await swal(
              `แก้ไขรายการสั่งสินค้า ${this.orderdetaildata.order_no} เรียบร้อย`,
              {
                icon: "success",
                buttons: "ตกลง",
              }
            );
            this.$router.push("/approveorder");
          }
          this.isLoading = false;
        } else {
          this.isLoading = false;
          await swal({
            title: `กรุณาเลือกสินค้า`,
            icon: "warning",
            dangerMode: true,
            buttons: "ตกลง",
          });
        }
      } catch (error) {
        this.isLoading = false;
        await swal({
          title: `ระบบผิดพลาด`,
          text: "กรุณาลองอีกครั้งในภายหลัง",
          icon: "warning",
          dangerMode: true,
          buttons: "ตกลง",
        });
      }
    },
    deleteproduct(pid) {
      this.productitems = this.productitems.filter(
        (pitem) => pitem._id !== pid
      );
      this.setamount();
    },
    cancel() {
      this.$router.push("/approveorder");
    },
    openorderproductmodal() {
      this.currentorderproduct = JSON.stringify(this.productitems);
      this.currentcustomerid = this.orderdetaildata.customer_id;
      this.orderproductmodal = true;
    },
  },
  computed: {
    orderproductmodal: sync("orderproductmodal"),
    currentorderproduct: sync("currentorderproduct"),
    currentcustomerid: sync("currentcustomerid"),
  },
  watch: {
    currentorderproduct() {
      this.setdata();
    },
    $route(to, from) {
      window.scrollTo(0, 0);
      this.getdata();
    },
  },
};
</script>

<style scoped >
.container {
  margin: 5px;
}
.container .con {
  margin: 0px;
}
.headlinestyle {
  font-family: "Kanit";
  font-style: normal;
  font-weight: normal;
  font-size: 30px;
  line-height: 54px;
  color: #000000;
}
.v-data-table th {
  height: 60px !important;
}
.round {
  position: relative;
}

.round label {
  background-color: #fff;
  border: 2px solid #929192;
  border-radius: 50%;
  cursor: pointer;
  height: 20px;
  left: 0;
  position: absolute;
  top: 4px;
  width: 20px;
}

.round label:after {
  border: 2px solid #fff;
  border-top: none;
  border-right: none;
  content: "";
  height: 6px;
  left: 2px;
  opacity: 0;
  position: absolute;
  top: 4.5px;
  transform: rotate(-45deg);
  width: 12px;
}

.round input[type="checkbox"] {
  visibility: hidden;
}

.round input[type="checkbox"]:checked + label {
  background-color: #fa8072;
  border-color: #ee5787;
}

.round input[type="checkbox"]:checked + label:after {
  opacity: 1;
}

.v-btn {
  font-family: "Kanit";
  font-weight: bold;
}
</style>
